<template>
  <div class="blacklistHome w100p">
    <!-- 广告轮播区域 -->
    <div class="blacklist-box row align-items-center">
      <div class="col-24">
        <div class="text-center font-bold fc-white fs-large pb7">查询“不诚信”人员</div>
        <van-search
          v-model="params.keywords"
          shape="round"
          show-action
          :clearable="false"
          placeholder="请输入人名或身份证号或手机号"
          @search="search"
          background="#3775ec"
        >
          <template #action>
            <div :style="actionStyle" @click="search">搜索</div>
          </template>
        </van-search>
      </div>
    </div>
    <div class="blacklist-desc">
      <p class="fc-less">问：什么是“不诚信”人员？</p>
      <p class="pt5">答：根据网友提供资料，工作人员从旁核实的水产骗子(骗钱或货等)、水产老赖(欠钱不还)、不诚信经营(以小充大、以差充好等)</p>
    </div>
    <!-- <div class="padding10">
      <van-button @click="report" type="danger">点我举报</van-button>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import storage from '@/uitls/cacheUtil';

export default Vue.extend({
  name: 'BlackList',
  components: {},
  data() {
    return {
      actionStyle: {
        // color: '#ffffff',
        width: '60px',
        height: '36px',
        'line-height': '36px',
        'background-color': 'yellow',
        'font-weight': 'bold',
        'border-radius': '20px',
        'text-align': 'center',
      },
      params: {
        keywords: '',
      },
    };
  },
  methods: {
    search(val) {
      // console.log(this.params);
      // go(blacklistResult, this.params);
      storage.session.set('BLACK_PARAMS', this.params);
      this.$router.push('/black/list/result');
    },
  },
  created() {
    // this.getBlackList();
  },
});
</script>
<style scoped>
  .blacklistHome {
    min-height: 100vh;
    background-color: #ffffff;
    text-align: left;
  }
  .blacklist-box {
    background-color: #3775ec;
    height: 30vh;
    padding: 0 25px 20px 25px;
  }
  .blacklist-desc {
    padding: 30px 15px;
  }
  .blacklistHome >>> .van-search .van-field__control {
    border: none!important;
  }
  .blacklistHome >>> .van-search__action {
    background: transparent!important;
  }
</style>
